// @ts-nocheck
"use client";
import React, { useEffect, useState } from "react";
import { Input, Button, message } from "antd";
import {
	WhatsAppOutlined,
	SkypeOutlined,
	MailOutlined,
	RightOutlined,
	GlobalOutlined,
} from "@ant-design/icons";
import Image from "next/image";
import { Link } from "@/navigation";
import { LinkedinLogo, TiktokLogo } from "@phosphor-icons/react";
import { useCategory } from "@/context/CategoriesContext";
import FollowUs from "@/components/Social/FollowUs";
import { useTranslations } from "next-intl";
const { Search } = Input;
import { Menu, menus } from "@/lib/menu";
import { contactInfo } from "@/lib/contacts";
import Follow from "../Social/Follow";
import { useModalCustomerContext } from "@/context/CustomerContext";
import SliderBar from "../SliderBar";
import { subscribeEmail } from "@/lib/api/subscribe";
import Translate2 from "@/components/Translate/index2";

const Footer = () => {
	const { categories } = useCategory();

	const t = useTranslations();

	const [subscribeLoading, setSubscribeLoading] = useState(false);
	const subscribe = async (value: string) => {
		try {
			if (!value) return;
			setSubscribeLoading(true);
			await subscribeEmail({ email: value, subscribe_type: 3 });
			message.success(t("message.subscribeSuccess"));
		} catch (e) {
			message.error(e.message);
		}
		setSubscribeLoading(false);
	};

	const navigation = {
		QUICKLINKS: [
			{ id: 1, name: "menu.home", link: "/", hasSlug: true, show: true },
			{ id: 20, name: "menu.product", link: "/products", hasSlug: true, show: true },
			{ id: 3, name: "menu.blog", link: "/blog", hasSlug: true, show: true },
			{ id: 4, name: "menu.aboutUs", link: "/about-us", hasSlug: true, show: true },
			{ id: 5, name: "menu.contactUs", link: "/contact-us", hasSlug: true, show: true },
			// { id: 6, name: "menu.faqs", link: "/faqs", hasSlug: true, show: true },
		],
		support: [
			{ id: 1, name: "menu.User manuals", link: "/support#user-manuals", hasSlug: true, show: true },
			{ id: 3, name: "menu.Shipping", link: "/support#user-manuals?tab=shipping", hasSlug: true, show: true },
			{ id: 4, name: "menu.Retums", link: "/support#user-manuals?tab=returns", hasSlug: true, show: true },
			{ id: 5, name: "menu.Payments", link: "/support#user-manuals?tab=payments", hasSlug: true, show: true },
			{ id: 6, name: "menu.Warranty", link: "/support#user-manuals?tab=warranty", hasSlug: true, show: true },
			// { id: 6, name: "menu.faqs", link: "/faqs", hasSlug: true, show: true },
		],
		contact: [
			{
				name: `menu.Phone`,
				href: `tel:+1 (740) 350-7878`,
				value: `+1 (740) 350-7878`,
			},
			{
				name: `common.Email`,
				href: `mailto:${contactInfo.email}`,
				value: `${contactInfo.email}`,
			},
			{
				name: `common.WhatsApp`,
				href: `https://wa.me/17403507878`,
				value: `Stary Line`,
			},
			{
				name: `common.Address`,
				href: `https://maps.app.goo.gl/BBKgg8wypLD5k1W67`,
				value: `${contactInfo.address}`,
			},
		],
	};

	// 平滑滚动到顶部
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};
	useEffect(() => {
		if (window.devicePixelRatio === 1.25) {
			document.body.style.zoom = "0.8";
		}
	}, []);
	return (
		<footer className="footer bg-[#272727] font-poppins text-white">
			{/* logo */}
			<div className="container border-b-[1px] border-[#363636] py-[30px] max-md:py-3">
				<div className="  flex flex-col items-center justify-center gap-[16px]">
					<div className="text-[30px] font-bold">
						<p>{t("home.f1")}</p>
					</div>
					<div className="text-[#A3A3A3]">
						<p>{t("home.f2")}</p>
					</div>
					<div>
						<button className="h-[35px] w-[115px] rounded-md  !bg-main">
							<Link href="/products" className="font-bold !text-white hover:!text-black ">
								{t("home.Shop Now")}
							</Link>
						</button>
					</div>
				</div>
			</div>

			<div className="container flex  gap-[250px] px-4 py-[40px] max-2xl:gap-[100px] max-xl:gap-[30px] max-lg:grid-cols-2 max-lg:flex-col max-lg:gap-[20px] max-md:grid-cols-1 max-md:flex-col max-md:py-3 ">
				{/* 第一部分 */}
				<div className=" max-lg:mr-0 max-md:mr-0">
					<h3 className=" mb-4 text-[45px] max-md:text-[25px]  ">{t("home.f3")}</h3>

					<div className="mb-[150px] max-lg:mb-[30px] max-lg:mr-[400px] max-md:mb-[30px]  max-md:mr-[400px]">
						<Search
							placeholder={t("footer.emailAddress")}
							enterButton={
								<span className="flex items-center  ">
									<div className="flex h-[20px] w-[20px] items-center justify-center rounded-2xl bg-[#E9E9E9]">
										<RightOutlined style={{ fontSize: "10px", color: "black", fontWeight: "bold" }} />
									</div>
								</span>
							}
							size="large"
							className="mt-4 text-black "
							onSearch={(value) => subscribe(value)}
						/>
					</div>

					<div className="mb-4">
						<Follow />
					</div>
					<div>
						<p className="text-[#8E8E8E]">STARY LLC © 2024. All rights reserved.</p>
					</div>
				</div>
				{/* 第二部分 */}
				{/* <div className="mr-[170px] w-[100px]">
					<h3 className=" mb-4 text-[16px] font-bold uppercase">{t("menu.our products")}</h3>
					<ul className="space-y-2">
						{categories?.edges?.map((item) => {
							return (
								<li key={item.node.id}>
									<Link href={"/products/" + item.node.slug} className="text-[#8E8E8E]">
										{item.node.name}
									</Link>
								</li>
							);
						})}
					</ul>
				</div> */}
				{/* 产品菜单  用不到先注释 */}
				<div className=" max-xl:mr-[20px]">
					<h3 className=" e mb-4 text-[16px] font-bold">{t("menu.Support")}</h3>
					<ul className="space-y-2">
						{navigation.support.map((item) => {
							return (
								item.show && (
									<li key={item.id}>
										<Link
											href={item.link}
											className="whitespace-nowrap text-nowrap text-[#8E8E8E]"
											onClick={(e) => {
												e.preventDefault();
												// 导航到支持页面，并通过URL传递参数
												window.location.href = item.link;
											}}
										>
											<span className="whitespace-nowrap">{t(item.name)}</span>
										</Link>
									</li>
								)
							);
						})}
					</ul>
				</div>

				{/* 第三部分 */}

				<div className="   max-xl:mr-[0px]">
					<h3 className=" mb-4  whitespace-nowrap text-[16px] font-bold">{t("menu.Quick Iinks")}</h3>
					<ul className="space-y-2">
						{navigation.QUICKLINKS.map((item) => {
							return (
								item.show && (
									<li key={item.id}>
										<Link href={item.link} className="whitespace-nowrap text-[#8E8E8E]">
											<span className="whitespace-nowrap">{t(item.name)}</span>
										</Link>
									</li>
								)
							);
						})}
					</ul>
				</div>

				{/* 第四部分 */}

				<div className="">
					<div className="mb-[25px] ">
						<h3 className=" mb-4 text-[16px] font-bold ">{t("menu.Contact Us")}</h3>
						<ul className="space-y-2 leading-[25px]">
							{navigation.contact.map((item) => {
								return (
									<li key={item.name}>
										<Link href={item.href} className="whitespace-nowrap text-[#8E8E8E]">
											<span className="whitespace-nowrap">
												{t(item.name)}: {item.value}
											</span>
										</Link>
									</li>
								);
							})}
						</ul>
					</div>
					<div className="flex ">
						{/* <GlobalOutlined /> */}
						<div className="ml-1">
							<Translate2 lastScrollPosition={0}></Translate2>
						</div>
						<Link href="/" className="text-white">
							<p className="ml-4 leading-[40px]">sitemap</p>
						</Link>
					</div>
					<div className="mt-[60px] flex gap-1">
						{Array.from({ length: 10 }).map((item, index) => {
							return (
								<img
									src={`/image/paySvg/${index + 1}.svg`}
									key={index}
									className="h-[20px] !w-[40px]"
									alt=""
								/>
							);
						})}
					</div>
				</div>
			</div>

			{/* <SliderBar /> */}
		</footer>
	);
};

export default Footer;
function SearchInput({ onSearch, className }: any) {
	const [searchValue, setSearchValue] = useState("");
	const t = useTranslations();
	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === "Enter") {
			onSearch(e.currentTarget.value);
		}
	};
	const toSearch = () => {
		// router.push(`/search?q=${value}`);
		onSearch(searchValue);
	};
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearchValue(e.target.value);
	};
	return (
		<div className="!h-[53px] w-full text-[14px]">
			<div
				className={clsx(
					"s-flex box-border flex h-full  w-full   rounded-[30px] !bg-[#2c2c2c] !p-[6px]",
					className || "",
				)}
			>
				<input
					value={searchValue}
					onChange={handleChange}
					onKeyDown={handleKeyDown}
					className="!text-mainText flex-1 !bg-[#2c2c2c]  py-0.5 !pl-2"
					placeholder={t("nav.Enter")}
					autoComplete="off"
				/>
				<button
					onClick={toSearch}
					type="submit"
					className="myhover flex items-center  rounded-3xl bg-[#000000]  px-6 py-2 focus:outline-none focus:ring-offset-2 "
				>
					<span className="pr-2 ">{t("nav.Subscribe")}</span>
					<svg
						className="hdt-icon hdt-icon-2"
						xmlns="http://www.w3.org/2000/svg"
						width="8"
						height="8"
						viewBox="0 0 64 64"
						fill="#fff"
					>
						<path d="M6.89,64,0,57.11,47.26,9.85H4.92V0H64V59.08H54.15V16.74Z"></path>
					</svg>
				</button>
			</div>
		</div>
	);
}
